<!-- Drag overlay (shown when file is being dragged over) -->
<div class="drag-overlay" *ngIf="isDragging">
  <div class="drag-overlay-content">
    <cds-icon shape="upload-cloud" size="64"></cds-icon>
    <p>{{ dropzoneText }}</p>
    <span class="file-hint">{{ dropzoneHint }}</span>
  </div>
</div>

<!-- Upload button -->
<label class="upload-button btn btn-sm btn-primary-outline"
       [class.disabled]="disabled"
       [attr.aria-disabled]="disabled ? true : null">
  <cds-icon shape="upload-cloud" solid style="margin-right: 4px;"></cds-icon>
  Datei hochladen
  <input type="file"
         [accept]="allowedExtensions.join(',')"
         [disabled]="disabled"
         (change)="onFileSelected($event)"
         hidden />
</label>

<!-- Upload Modal -->
<div class="upload-modal-overlay" *ngIf="showUploadModal" (click)="cancelUpload()">
  <div class="upload-modal" (click)="$event.stopPropagation()">
    <div class="upload-modal-header">
      <h4>{{ modalTitle }}</h4>
      <button class="close-btn" (click)="cancelUpload()" [disabled]="isUploading">×</button>
    </div>

    <div class="upload-modal-body">
      <!-- File info -->
      <div class="file-info" *ngIf="selectedFile">
        <cds-icon shape="file" size="24"></cds-icon>
        <div class="file-details">
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">{{ formatFileSize(selectedFile.size) }}</span>
        </div>
      </div>

      <!-- Title input -->
      <div class="form-group">
        <label for="uploadTitle">{{ titleLabel }}</label>
        <input type="text"
               id="uploadTitle"
               class="clr-input"
               [(ngModel)]="uploadTitle"
               [placeholder]="titlePlaceholder"
               [disabled]="isUploading" />
      </div>

      <!-- Error message -->
      <div class="upload-error" *ngIf="errorMessage">
        <cds-icon shape="exclamation-circle" solid></cds-icon>
        {{ errorMessage }}
      </div>

      <!-- Progress bar -->
      <div class="upload-progress" *ngIf="isUploading">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="uploadProgress"></div>
        </div>
        <span class="progress-text">{{ uploadProgress }}%</span>
      </div>
    </div>

    <div class="upload-modal-footer">
      <button class="btn btn-outline" (click)="cancelUpload()" [disabled]="isUploading">
        Abbrechen
      </button>
      <button class="btn btn-primary" (click)="uploadFile()" [disabled]="isUploading || !uploadTitle.trim()">
        <span *ngIf="!isUploading">
          <cds-icon shape="upload-cloud" solid style="margin-right: 4px;"></cds-icon>
          Hochladen
        </span>
        <span *ngIf="isUploading">Wird hochgeladen...</span>
      </button>
    </div>
  </div>
</div>
